import { FC } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { TagWithUsage } from "services/tags/type"

export const TagsTable: FC<{
  rows: TagWithUsage[]
  loading: boolean
  onEdit: (t: TagWithUsage) => void
  onDelete: (t: TagWithUsage) => void
}> = ({ rows, loading, onEdit, onDelete }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table w-full text-black dark:text-white">
        <thead className="text-black/70 dark:text-white/80">
          <tr>
            <th>Name</th>
            <th>Slug</th>
            <th>Category</th>
            <th>Priority</th>
            <th>Auto</th>
            <th>Usage</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7}>
                <div className="flex items-center gap-2">
                  <span className="loading loading-spinner loading-md" />
                  <span>{t("common.loading")}</span>
                </div>
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={7} className="opacity-70">
                {t("tags.noTagsFound")}
              </td>
            </tr>
          ) : (
            rows
              .slice()
              .sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0) || a.name.localeCompare(b.name))
              .map((tag) => (
                <tr key={tag.id} className="hover:bg-black/5 dark:hover:bg-white/5">
                  <td>
                    <div className="flex items-center gap-2">
                      <span className="inline-block h-3 w-3 rounded-full" style={{ backgroundColor: tag.color ?? "#64748B" }} />
                      <span className="font-medium">{tag.name}</span>
                    </div>
                  </td>
                  <td className="opacity-80">{tag.slug}</td>
                  <td>{tag.category ?? "-"}</td>
                  <td>{tag.priority ?? 0}</td>
                  <td>{tag.isAutomatic ? "Yes" : "No"}</td>
                  <td>
                    <span
                      className={clsx((tag.usageCount ?? 0) > 0 && "badge badge-sm badge-outline")}
                      title={(tag.usageCount ?? 0) > 0 ? (t("tags.usageDeleteWarning") as string) : undefined}
                    >
                      {tag.usageCount ?? 0}
                    </span>
                  </td>
                  <td className="text-right">
                    <div className="flex justify-end gap-2">
                      <button className="btn btn-xs" onClick={() => onEdit(tag)}>
                        {t("common.edit")}
                      </button>
                      <button className="btn btn-xs btn-error" onClick={() => onDelete(tag)} title={t("common.delete") as string}>
                        {t("common.delete")}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
          )}
        </tbody>
      </table>
    </div>
  )
}
